import { render, staticRenderFns } from "./ViewProfessionalCertificate.vue?vue&type=template&id=9112b31a&scoped=true"
import script from "./ViewProfessionalCertificate.vue?vue&type=script&lang=js"
export * from "./ViewProfessionalCertificate.vue?vue&type=script&lang=js"
import style0 from "./ViewProfessionalCertificate.vue?vue&type=style&index=0&id=9112b31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9112b31a",
  null
  
)

export default component.exports